import React from 'react';
import { Empty, Spin } from 'antd';

import BaseTable from '@components/common/BaseTable';

import { IManagementTableProps } from './typed';
import { ManagementTableWrapper, BaseTableWrapper } from './styled';

const DEFAULT_HEADER_BACKGROUND_COLOR = '#f6f6f6';

const ManagementTable: React.FC<IManagementTableProps> = (props) => {
  const { loading, header, detail, data, ...otherProps } = props;
  const isEmpty = !data || data.length === 0;

  return (
    <Spin spinning={loading}>
      <ManagementTableWrapper>
        {header}
        <BaseTableWrapper style={isEmpty ? { height: '20%' } : {}}>
          <BaseTable
            headerBackgroundColor={DEFAULT_HEADER_BACKGROUND_COLOR}
            data={data}
            {...otherProps}
          />
          {detail}
        </BaseTableWrapper>
        {isEmpty ? <Empty /> : null}
      </ManagementTableWrapper>
    </Spin>
  );
};

export default ManagementTable;
